import React from 'react';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';
import { Input } from './ui/input';

const ordinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const ManagementAccountsField = ({ form, setForm }) => (
  <div className="rounded-lg border border-stone-200 p-4" data-testid="mgmt-accounts-field">
    <div className="flex items-start gap-3">
      <Checkbox
        id="mgmtAccounts"
        checked={!!form.managementAccounts}
        onCheckedChange={(v) => setForm({ ...form, managementAccounts: !!v, managementAccountsDueDay: v ? (form.managementAccountsDueDay || 15) : form.managementAccountsDueDay })}
        className="mt-0.5"
        data-testid="mgmt-accounts-checkbox"
      />
      <div>
        <Label htmlFor="mgmtAccounts" className="cursor-pointer">Needs monthly management accounts</Label>
        <div className="text-xs text-stone-500 mt-0.5">A "Monthly Management Accounts" task is added to Tasks automatically every month.</div>
      </div>
    </div>
    {form.managementAccounts && (
      <div className="mt-3 pl-7 flex items-center gap-2 flex-wrap">
        <Label htmlFor="mgmtDay" className="text-sm font-normal text-stone-700">Due by day</Label>
        <Input
          id="mgmtDay"
          type="number"
          min="1"
          max="31"
          required
          value={form.managementAccountsDueDay ?? ''}
          onChange={(e) => setForm({ ...form, managementAccountsDueDay: e.target.value ? Math.min(31, Math.max(1, Number(e.target.value))) : null })}
          className="w-20 h-9"
          data-testid="mgmt-accounts-due-day-input"
        />
        <span className="text-xs text-stone-500">
          of each month{form.managementAccountsDueDay ? ` (e.g. the ${ordinal(form.managementAccountsDueDay)}, for the previous month's accounts)` : ''}
        </span>
      </div>
    )}
  </div>
);
